<template>
  <div class="c-feedback-mask">
    <div class="c-feedback">
      <i class="el-icon-close" @click="$emit('close')"></i>
      <p class="c-title">
        <span>问题反馈</span>
      </p>
      <div class="c-item">
        <span class="c-label">题目ID：</span>
        <span>{{data}}</span>
      </div>
      <div class="c-item">
        <span class="c-label">问题描述：</span>
        <textarea
          v-model="description"
          placeholder="请至少输入5个字"
        />
      </div>
      <footer>
        <button @click="feedback" :disabled="disabled">确 定</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { feedBack } from '@/api/pt';
import { CRM_USER } from '@/config/storage';

export default {
  name: 'Feedback',
  props: {
    data: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      description: '',
    };
  },
  computed: {
    disabled() {
      return this.description.length <= 5;
    },
  },
  methods: {
    feedback() {
      feedBack({
        teacher_id: (JSON.parse(localStorage.getItem(CRM_USER)) || {}).id,
        question_uuid: this.data,
        content: this.description,
      }).then((res) => {
        if (res.code === 200) {
          this.$emit('close');
          this.$message.success('感谢您的反馈');
        } else {
          this.$message.error('反馈失败，请稍后再试');
        }
      }).catch(() => {
        this.$message.error('反馈失败，请稍后再试');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-feedback-mask {
  background: rgba(0,0,0, 0);
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-feedback {
  width: 550px;
  padding: 28px 50px;
  background: #FFFFFF;
  border-radius: 16px;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: .3);
  position: relative;
  .el-icon-close {
    font-size: 30px;
    position: absolute;
    top: 17px;
    right: 17px;
  }
  .c-item {
    display: flex;
    font-size: 16px;
    color: #000;
    margin-bottom: 24px;
    .c-label {
      width: 93px;
    }
  }
  textarea {
    border: 1px solid rgba(216, 220, 230, 1);
    height: 80px;
    box-sizing: border-box;
    padding: 13px 15px;
    flex: 1;
    background: #FFFFFF;
    border-radius: 4px;
  }
  .c-title {
    color: #000;
    font-size: 24px;
    text-align: center;
    margin-bottom: 40px;
    span {
      position: relative;
      &::after {
        position: absolute;
        content: '';
        width: 100%;
        height: 13px;
        left: 0;
        bottom: 5px;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
    }
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      width: 218px;
      height: 40px;
      background: #1989FA;
      border-radius: 4px;
      color: #fff;
      font-size: 15px;
      &:disabled {
        background: lightgrey;
      }
    }
  }
}
</style>
